import { createPortal } from "react-dom";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import VoidReceiptPrintPage from "../../../pages/VoidReceiptPrintPage";
import { getAutoPrint } from '../../../utils/printerSettings';
import { electronPrint, isElectron } from '../../../services/electronPrint.service';

export default function ModalVoidBillPrint({ isOpen, onPrintComplete }) {
  const billData = useSelector((state) => state.bill.data);
  const pos = useSelector((state) => state.pos);

  useEffect(() => {
    if (!isOpen) return;

    const printTimer = setTimeout(async () => {
      if (isElectron()) {
        await electronPrint('voidBill', { billData, pos });
        if (onPrintComplete) setTimeout(() => onPrintComplete(), 200);
        return;
      }
      if (getAutoPrint()) {
        window.print();
        if (onPrintComplete) {
          setTimeout(() => onPrintComplete(), 500);
        }
      }
    }, 500);

    return () => clearTimeout(printTimer);
  }, [isOpen, onPrintComplete, billData, pos]);

  if (!isOpen) return null;

  return (
    <>
      {createPortal(
        <div className="section-to-print-receipt-page pb-10">
          <VoidReceiptPrintPage />
        </div>,
        document.body
      )}
    </>
  );
}
